<template>
  <div>
    <doctor-header></doctor-header>
    <div class="header-separator"></div>

    <div style="background-color: white;" v-if="isLogin == undefined">
      <div style="margin: 1rem; padding: 1rem 0;" class="text-md-center">

<!--        <h3 class="doctors-container&#45;&#45;sections text-uppercase text-md-center mt-4">Chwila... </h3><br><br>-->
        <img style="margin: 0 auto;" src="/static/images/spinner.gif"  />

      </div>
    </div>
    <div style="background-color: rgba(255, 255, 255, .9); margin-top: 200px;" v-if=" isLogin == false">
      <v-container class="site-padding">
        <v-layout align-center justify-center row wrap class="doctors-container mx-1">
          <v-flex xs12 class="text-xs-left">
            <h1 class="doctors-container--header pt-4">Ten link nie działa. Zarejestruj się i opłać dostęp do transmisji, bądź skontaktuj z administratorem.</h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle"></div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container class="site-padding" >
        <v-layout row class="mt-3">
          <v-flex class="xs12 sm6">
            <my-button
              toName="ForumOnline"
              title="Zapisz się na transmisję online"
              text="<span>Zapisz się na transmisję online</span>"
              customClass="doctor rect-x1"
            />
          </v-flex>
        </v-layout>
      </v-container>

    </div>

    <div style="background-color: rgba(255, 255, 255, .9); margin-top: 200px;" v-if="isLogin == true">
      <v-container class="site-padding mt-3" id="polishGluacomaSection">
        <v-layout align-center justify-center row wrap class="doctors-container">
          <v-flex xs12 class="text-xs-left">
            <h1 class="register-form--header">iv polskie forum jaskry - transmisja</h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle"></div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container class="site-padding" v-if="!hideForum">
        <v-layout align-center justify-center row wrap class="doctors-container my-text">
          <v-flex xs12 class="text-xs-left">
            <div>
              <span class="doctors-container--sections font-weight-bold">Polskie Towarzystwo Okulistyczne</span>
              <span>zaprasza na konferencję naukową</span>
              <span class="doctors-container--sections font-weight-bold">"Polskie Forum Jaskry",</span>
              <span>na którym zostaną poruszone aktualne tematy związane z&nbsp;jaskrą -&nbsp;"cichym złodziejem wzroku". Konferencja odbędzie się w dniu 7 marca 2020 roku w</span>
              <span class="doctors-container--sections font-weight-bold">Digital Knowledge Village, ul. Puławska 457 Warszawa.</span>
              <span>Wydarzenie poprzedza rozpoczynający się 8-go marca</span>
              <span class="doctors-container--sections font-weight-bold">"Światowy Tydzień Jaskry"</span>
              <span>-&nbsp;międzynarodowa inicjatywa lekarzy okulistów mająca na celu podniesienie świadomości społeczeństwa na temat jaskry oraz zwiększenie jej wykrywalności we wczesnych stadiach zaawansowania. Już teraz zapisz się na to wyjątkowe wydarzenie.</span>
            </div>
<!--            <div class="pt-3" v-if="timeout">-->
<!--              <span class="doctors-container&#45;&#45;sections text-uppercase font-weight-bold">{{ wgw_user.first_name }}</span>-->
<!--              <span>w celu pobrania certyfikatu</span>-->
<!--              <a :href="this.urlPath + '/' + this.path" class="register-form&#45;&#45;links font-weight-bold" target="_blank" @click="storeDownloadCertificate()">kliknij tutaj</a>-->
<!--            </div>-->
            <div class="pt-3" v-if="timeout">
              <div style="max-width:960px;min-width:270px;padding:0;margin:0;">
                <div style="position: relative; padding-bottom: 56.25%; padding-top: 0px; height: 0; overflow: hidden;">
                  <iframe style="padding:0;margin:0;overflow:hidden;position: absolute; top:0; left: 0; width: 100%; height: 100%;" frameborder="0" scrolling="no" src="https://cdn.playlive.net/uplayer-legacy/get.html?nflivesecondarycm3sp3dds0cms30xx16749df1" width="640" height="360" webkitallowfullscreen mozallowfullscreen allowfullscreen allow="autoplay; fullscreen"></iframe>
                </div>
                <iframe class="mt-5" style="border:0;padding:0;margin:0; width: 100%; height: 500px;" frameborder="0" src="https://streamonline.biz/applications/bigchat/?c=4fe5a854c805033a577234e945be0005bf8c93cb&r=62e7b174f700a2596b586299d7935dea5454e68c"></iframe>
              </div>
            </div>
          </v-flex>
          <v-flex xs12 class="text-xs-left pt-3" v-if="!timeout">
            <img
              src="./../../static/images/refreshBanner_2020-01-27_PCH.png"
              width="100%"
              @click="reloadPage"
            >
            <Countdown2 v-if="!hide_countdown" :date="start"></Countdown2>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container class="site-padding" v-if="hideForum">
        <v-layout align-center justify-center row wrap class="doctors-container my-text">
          <v-flex xs12 class="text-xs-left">
            <div>
              <span class="doctors-container--sections font-weight-bold">Transmisja z IV Polskiego Forum Jaskry była dostępna 7 marca 2020 w godzinach 09:0-14:00. </span>
            </div>
            <div>
              <span>Zapraszamy za rok.</span>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div class="header-separator" style="height: 50px;"></div>
  </div>
</template>

<script>
import DoctorHeader from '@/components/partials/DoctorHeader';
import MyButton from '@/components/partials/Button';
import Countdown2 from '@/components/partials/Countdown2';
import moment from 'moment';

export default {
  data() {
    return {
      hideForum: false,
      isLogin: undefined,
      dialog1: false,
      isDisabled: false,
      valid: true,
      wgw_user: '',
      hide_countdown: false,
      path: '',
      start: '',
      timeout: false,
      urlPath: process.env.APP_URL,
      showCertificate: true,
      currentTime: '',
      showTime: '',
      enterTime: '',
      checkTime: '',
      participant: {
        first_name: '',
        last_name: '',
        email: '',
        pwz: '',
        birthday: '',
      },

    };
  },
  components: {
    DoctorHeader,
    MyButton,
    moment,
    Countdown2,
  },
  beforeMount() {
    this.fetchParticipant(this.$route.params.token);

  },
  mounted() {
    this.fetchParticipant(this.$route.params.token);
    if(window.localStorage.getItem('enterTime')) {
      this.checkTime = window.localStorage.getItem('enterTime');
      this.currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
      this.showTime = window.localStorage.getItem('showTime');
      // this.isLogin = true;

    } else {
      this.enterTime = moment().format('YYYY-MM-DD HH:mm:ss');
      window.localStorage.setItem('enterTime', this.enterTime);
      this.checkTime = window.localStorage.getItem('enterTime');
      this.currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
      this.showTime = moment(this.currentTime).add(2, 'minutes').format('YYYY-MM-DD HH:mm:ss');
      window.localStorage.setItem('showTime', this.showTime);
    }
    setInterval(this.sendTime(), 1000);

    if((moment().format('YYYY-MM-DD HH:mm:ss') > '2020-03-07 08:45:00') && (moment().format('YYYY-MM-DD HH:mm:ss') < '2020-03-09 20:00:00'))
    {
      this.timeout = true;
    } else {
      this.timeout = false;
      this.start =  '2020-03-07 08:45:00';
    }
    // this.check_countdown();
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    fetchParticipant(token) {
      this.axios({
        method: 'GET',
        url: `${process.env.APP_URL}/api/get-online/${token}`,
      })
      .then(result => {
        this.wgw_user = result.data;
        // this.participant.first_name = this.wgw_user.first_name;
        // this.participant.last_name = this.wgw_user.last_name;
        this.participant.email = this.wgw_user.email;
        this.participant.email_token = this.wgw_user.email_token;
        // this.participant.birthday = this.wgw_user.birthday;
        // this.path = this.wgw_user.path;
        if(!this.wgw_user.email_token)
        {
          this.isLogin = false;
        } else {
          this.isLogin = true;
          this.hideForum = false;
        }
      }, err => {
        this.isLogin = false;
      });
    },
    afterForum() {
        const dateToCheck = '2020-03-9 20:00:00';
        if (moment().isAfter(dateToCheck)) {
          // return true;
          this.hideForum = true;
        }

    },
    showErrors(error) {
      this.$toasted.error(error, {
        theme: 'primary',
        position: 'bottom-right',
        duration: 5000,
      });
    },


    sendTime() {
      const data = {
        'token': window.localStorage.getItem('wgwtoken')
      }

      this.axios({
        method: 'POST',
        url: `${process.env.APP_URL}/api/store-time`,
        data,
      })
      .then((response) => {},
      (response) => {
        Object.keys(response.response.data.errors).map((key) => response.response.data.errors[key].map((error) => this.showErrors(error)))
      });
      if(this.showTime <= this.currentTime)
      {
        this.showCertificate = true;
      } else {
        this.showCertificate = false;
      }
    }
  },
  created() {
    this.sendTime();

    setInterval(function () {
      // this.sendTime();
    }.bind(this), 3000);
  },
  computed: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.c-green {
  color: #007F00;
}
.term-container--position {
  align-items: baseline !important;
}
.navigation-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-content: end;
  align-items: end;
}
.navigation-container--position {
  order: 0;
  flex: 0 1 auto;
  align-self: center;
  border-bottom: 5px solid #fff;
}
.banner { background-color: transparent; }

.wrapper {
  width: 100%;
  margin: 0 auto;
}

.banner .text-container {
  font-family: 'Fira Sans', sans-serif;
  text-align: left;
  color: #aaa;
  display: block;
  vertical-align: middle;
 }
.banner img {
  float: left;
 }

.time-container {
  display: inline-flex;
  width: 100%;
}
.time-container--separator {
  width: 145px;
  padding-right: 5px;
}
.register-form--inputs {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
}
.register-form--header {
  font-size: 26px;
  font-family: 'Fira Sans', sans-serif;
  font-weight: 900;
  color: #a41611;
  text-transform: uppercase;
}
.register-form--links {
  color: #a41611;
  font-family: 'Fira Sans', sans-serif;
}
.register-form--sections {
  color: #275271;
  font-family: 'Fira Sans', sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}
.doctors-container--sections {
  color: #a41611;
}
.register-form--sections-slim {
  color: #000;
  font-weight: 500;
  text-transform: lowercase;
}
.register-form--icons {
  background: #275271;
  vertical-align: middle;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  line-height: 50px;
  border: none;
  padding: 5px;
}
.register-form--icons-brown {
  background: #a82824;
}
.sparator-container {
  border-bottom: 1px solid black;
  margin-bottom: 10px;
}
.sparator-rectangle {
  width: 115px;
  height: 8px;
  background-color: #275271;
}
.no-padding {
  padding: 0px !important;
  margin-top: 7px;
}
.register-bg {
  position: relative;
}
.register-bg::before {
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  content: '';
  position: fixed;
  opacity: 0.1;
  background-image: url('./../assets/images/register-bg.png');
  background-repeat: repeat;
  background-position: center center;
}
.doctor-header {
  background: #a82824;
  opacity: 0.9;
}
.free-main-header {
  background: #d9e7ee;
  opacity: 0.9;
}
.free-main-header--text {
  font-family: 'Fira Sans', sans-serif;
  font-size: 12px;
}
.main-header--wgw {
  width: 125px;
}
.main-header--pto {
  width: 90px;
}
@media only screen and (min-width: 1024px) and (max-width: 2560px) {
  .main-header--wgw {
    width: 240px;
  }
  .main-header--pto {
    width: 200px;
  }
}
.main-header--free {
  width: 280px;
}
.button-container-blue {
  background: #275271;
  opacity: 0.9;
}
.button-container-red {
  background: #a82824;
  opacity: 0.9;
  position: relative;
}
.button-container--register {
  font-family: 'Fira Sans', sans-serif;
  font-size: 40px;
  line-height: 40px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.doctor-header--text {
  font-family: 'Fira Sans', sans-serif;
  font-size: 50px;
  line-height: 50px;
  font-weight: 900;
  width: 50%;
  color: #fff;
  padding-left: 10px;
  padding-top: 20px;
  text-transform: uppercase;
}
.button-container--text {
  font-family: 'Fira Sans', sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.button-container--arrow {
  margin-right: 20px
}
.free-main-header--margin {
  margin-top: 100px;
}
.button-container--margin {
  margin-bottom: 30px;
}
.button-container--padding {
  padding-top: 50px!important;
  padding-bottom: 50px!important;
}
.button-container--position {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
}
.button-container--separator {
  position: absolute;
  top: 0;
  width: 115px;
  height: 10px;
  background: #ffffff;
}

.register-container--download {
  text-decoration: none;
    display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.register-container--download-text {
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  padding-left: 15px;
}
.register-container--sections {
  color: #275271;
  font-family: 'Fira Sans', sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/ForumCertificate.vue